export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_REGISTER = "AUTH_REGISTER";
export const AUTH_FORGOT = "AUTH_FORGOT";
export const AUTH_RESET = "AUTH_RESET";
export const AUTH_SUB = "AUTH_SUB";
export const SHARE_PROP = "SHARE_PROP";
export const ABOUT_FORM = "ABOUT_FORM";

export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_ERROR = "USER_ERROR";

export const NEW_ORDER = "NEW_ORDER";
export const PASS_RESET = "PASS_RESET";
export const TOKEN_DECODE = "TOKEN_DECODE";
